package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.max
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.Required
import kotlinx.serialization.Serializable
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.images.BulbSvg
import org.example.site_web.components.images.svgmasks.BulbMask
import org.example.site_web.components.widgets.ContactForm

import org.example.site_web.content.ideaContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

import kotlinx.serialization.json.Json

sealed class SubmitState {
    object SubmitStateNone : SubmitState()
    object Submitting : SubmitState()
    object Submitted : SubmitState()
}



@Serializable
data class ContactFormData (
    @Required val name:String="",
    @Required val company:String="",
    @Required val telephone:String="",
    @Required val email:String="",
    @Required val description:String=""
)


@Composable
fun IdeaBox(onSubmitClick: () -> Unit) {

    val idea = mutableStateOf(ideaContent.first())
    val frame = mutableStateOf(0.0)
    LaunchedEffect(true) {
        val perCharDelay = 100
        val subStates = 10
        var i = 0
        while (true) {
            frame.value = 0.0
            idea.value = ideaContent[i]
            var lt = 0
            val lta = idea.value.length
            val itTime: Double = 4000.0 / lta
            val framePerChar: Double = 100.0 / lta
            while (lt <= lta) {
                var sb = 0
                idea.value = ideaContent[i].substring(0, lt)
                while (sb < subStates) {
                    sb++
                    delay((perCharDelay.toDouble() / subStates.toDouble()).toLong())
                    frame.value += (framePerChar / subStates.toDouble())
                }
                lt++
            }
            i = if (i < ideaContent.size - 1) i + 1 else 0
        }
    }

    Column(horizontalAlignment = Alignment.CenterHorizontally) {

        Box(
            Modifier
                .width(min(60.vw, 20.em))
                .height(3.em)
                .margin(1.em)
                .padding(1.em)
                .border {
                    color(aiPalette.mainPalette.darkest)
                    style(LineStyle.Solid)
                    width(3.px)
                }.background {
                    color(Colors.Black)
                }.color(Colors.White),
            contentAlignment = Alignment.CenterStart
        ) { Text(idea.value) }

        Button(
            Modifier
                .fontSize(1.cssRem)
                .width(min(50.vw, 20.em))
                .height(3.em).toAttrs {
                    onClick { evt ->
                        evt.preventDefault()
                        onSubmitClick()
                    }
                }) {
            Text("Contactez-nous")
        }
    }
}


@Composable
fun YourProject() {
    val submitState = remember { mutableStateOf<SubmitState>(SubmitState.SubmitStateNone) }

    //BulbMask()
    Box(
        Modifier
            .fillMaxWidth()
            .padding(bottom = 2.em), contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier.width(min(70.vw, 1344.px))
                .padding {
                    topBottom(1.em)
                }, horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Center
        ) {
            Span(
                Modifier.fontSize(1.8.cssRem)
                    .fontWeight(FontWeight.SemiBold).toAttrs()
            )
            {
                AccTriangleIcon()
                Text("Votre projet")
            }

            Row(
                Modifier.margin(top = 2.em, bottom = 2.em)
                    .padding(topBottom = 2.em, leftRight = 2.em)
                    .backgroundColor(aiPalette.farBackColor)
                    .boxShadow(spreadRadius = 1.em, blurRadius = 1.em, color = aiPalette.farBackColor)
                    .border {
                        color(Colors.White)
                        width(2.px)
                        style(LineStyle.None)
                    }
                    .displayIfAtLeast(Breakpoint.LG)
                    .fillMaxHeight(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {

                Box(Modifier.onClick { evt ->
                    evt.preventDefault()
                    submitState.value = SubmitState.SubmitStateNone
                }) {
                    BulbSvg(
                        Modifier
                            .width(6.cssRem)
                            .height(6.cssRem), 50.0
                    )
                }
                ContactContent(submitState)
            }
            Column(
                Modifier
                    .fillMaxWidth()
                    .margin(top = 2.em, bottom = 2.em)
                    .padding(topBottom = 2.em, leftRight = 0.em)
                    .backgroundColor(aiPalette.farBackColor)
                    .boxShadow(spreadRadius = 1.em, blurRadius = 1.em, color = aiPalette.farBackColor)
                    .border {
                        color(Colors.White)
                        width(2.px)
                        style(LineStyle.None)
                    }
                    .displayUntil(Breakpoint.LG)
                    .fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Top
            ) {

                Box(Modifier.onClick { evt ->
                    evt.preventDefault()
                    submitState.value = SubmitState.SubmitStateNone
                }) {
                    BulbSvg(
                        Modifier
                            .width(6.cssRem)
                            .height(6.cssRem), 50.0
                    )
                }
                ContactContent(submitState)
            }
        }
    }
}

@Composable
fun ContactContent(submitState: MutableState<SubmitState>) {

    val scope = rememberCoroutineScope()

    when (submitState.value) {
        SubmitState.SubmitStateNone -> {
            console.log("None")
            IdeaBox(onSubmitClick = {
                submitState.value = SubmitState.Submitting
            })
        }

        SubmitState.Submitting -> ContactForm(onSubmitClick = {
            datas: ContactFormData->
            submitState.value = SubmitState.Submitted
            scope.launch {
                val contentByteArray = window.http.tryPost(
                    resource = "http://localhost:8080/",
                    headers = mapOf(
                        "Content-Type" to "text/plain"),
                    body = Json.encodeToString(datas).encodeToByteArray()
                )
                console.log(contentByteArray?.decodeToString())
            }
        })

        SubmitState.Submitted -> {
            Span(Modifier
                .textAlign(TextAlign.Center)
                .whiteSpace(WhiteSpace.PreWrap)
                .padding().toAttrs()) {
                Text("Serveur en maintenance.\r\nMerci de nous envoyer un mail à contact@accelarge.com")
            }
        }
    }
}